/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/label-has-for */

import React from 'react';
import moment from 'moment';

import TooltipForReceptionist from 'components/TooltipForReceptionist';
import PERM from 'constants/core/perm.const';
import IN from 'constants/in';
import { useTranslation } from 'providers/GILT.provider';

import Switcher from 'onboarding/common/forms/checkboxPopup/Switcher';

const OpeningHours = ({ settingsLayout, salonDetails, onOpenCheckboxChange, onOpenTimeChange, onCloseTimeChange }) => {
  const { t } = useTranslation();

  return (
    <div data-bem="OpeningHours" className="content">
      {!settingsLayout && (
        <div className="border-top-title cfix">
          <div className="form-horizontal col-lg-6">
            <div className="row">
              <div className="settings-heading col-xs-9">
                <div className="row">
                  <label>{t('register.openingHoursWrap.openingHoursLabel')}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="salon-opening-hours-layout">
        <div className="t-container-hours relative">
          <Switcher
            dayName={t('common.days.monday')}
            isOpen={salonDetails.mon_open}
            openTime={moment(salonDetails.mon_open_time, 'HH:mm:ss')}
            closeTime={moment(salonDetails.mon_close_time, 'HH:mm:ss')}
            onOpenCheckboxChange={onOpenCheckboxChange}
            onOpenTimeChange={onOpenTimeChange}
            onCloseTimeChange={onCloseTimeChange}
          />
          <TooltipForReceptionist permission={PERM.canEditBusinessInfoHours} where={IN.hours} />
        </div>
        <div className="t-container-hours relative">
          <Switcher
            dayName={t('common.days.tuesday')}
            isOpen={salonDetails.tue_open}
            onOpenCheckboxChange={onOpenCheckboxChange}
            openTime={moment(salonDetails.tue_open_time, 'HH:mm:ss')}
            closeTime={moment(salonDetails.tue_close_time, 'HH:mm:ss')}
            onOpenTimeChange={onOpenTimeChange}
            onCloseTimeChange={onCloseTimeChange}
          />
          <TooltipForReceptionist permission={PERM.canEditBusinessInfoHours} where={IN.hours} />
        </div>
        <div className="t-container-hours relative">
          <Switcher
            dayName={t('common.days.wednesday')}
            isOpen={salonDetails.wed_open}
            onOpenCheckboxChange={onOpenCheckboxChange}
            openTime={moment(salonDetails.wed_open_time, 'HH:mm:ss')}
            closeTime={moment(salonDetails.wed_close_time, 'HH:mm:ss')}
            onOpenTimeChange={onOpenTimeChange}
            onCloseTimeChange={onCloseTimeChange}
          />
          <TooltipForReceptionist permission={PERM.canEditBusinessInfoHours} where={IN.hours} />
        </div>
        <div className="t-container-hours relative">
          <Switcher
            dayName={t('common.days.thursday')}
            isOpen={salonDetails.thu_open}
            onOpenCheckboxChange={onOpenCheckboxChange}
            openTime={moment(salonDetails.thu_open_time, 'HH:mm:ss')}
            closeTime={moment(salonDetails.thu_close_time, 'HH:mm:ss')}
            onOpenTimeChange={onOpenTimeChange}
            onCloseTimeChange={onCloseTimeChange}
          />
          <TooltipForReceptionist permission={PERM.canEditBusinessInfoHours} where={IN.hours} />
        </div>
        <div className="t-container-hours relative">
          <Switcher
            dayName={t('common.days.friday')}
            isOpen={salonDetails.fri_open}
            onOpenCheckboxChange={onOpenCheckboxChange}
            openTime={moment(salonDetails.fri_open_time, 'HH:mm:ss')}
            closeTime={moment(salonDetails.fri_close_time, 'HH:mm:ss')}
            onOpenTimeChange={onOpenTimeChange}
            onCloseTimeChange={onCloseTimeChange}
          />
          <TooltipForReceptionist permission={PERM.canEditBusinessInfoHours} where={IN.hours} />
        </div>
        <div className="t-container-hours relative">
          <Switcher
            dayName={t('common.days.saturday')}
            isOpen={salonDetails.sat_open}
            onOpenCheckboxChange={onOpenCheckboxChange}
            openTime={moment(salonDetails.sat_open_time, 'HH:mm:ss')}
            closeTime={moment(salonDetails.sat_close_time, 'HH:mm:ss')}
            onOpenTimeChange={onOpenTimeChange}
            onCloseTimeChange={onCloseTimeChange}
          />
          <TooltipForReceptionist permission={PERM.canEditBusinessInfoHours} where={IN.hours} />
        </div>
        <div className="t-container-hours relative">
          <Switcher
            dayName={t('common.days.sunday')}
            isOpen={salonDetails.sun_open}
            onOpenCheckboxChange={onOpenCheckboxChange}
            openTime={moment(salonDetails.sun_open_time, 'HH:mm:ss')}
            closeTime={moment(salonDetails.sun_close_time, 'HH:mm:ss')}
            onOpenTimeChange={onOpenTimeChange}
            onCloseTimeChange={onCloseTimeChange}
          />
          <TooltipForReceptionist permission={PERM.canEditBusinessInfoHours} where={IN.hours} />
        </div>
      </div>
    </div>
  );
};

export default OpeningHours;
